function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 4,
  y1: 408.7,
  x2: 176.7,
  y2: 408.7,
  gradientTransform: "matrix(1 0 0 -1 0 570)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e20613"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f29100"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M4 121l80.6 80.6h92.1L142.2 167l-46.1-46z"
});

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  gradientUnits: "userSpaceOnUse",
  x1: 234.731,
  y1: 374.2,
  x2: 413.513,
  y2: 374.2,
  gradientTransform: "matrix(1 0 0 -1 0 570)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f29232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffee2b"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M407.1 236.1l-80.7-80.6h-92.1l11.5 11.5 23.1 23.1 46 46z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#1d70b7",
  d: "M95.6 121l69.1-69.1H268.4l-34.6 34.5H326l80.6-80.6H118.7L3.5 121"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  gradientUnits: "userSpaceOnUse",
  x1: 3.5,
  y1: 506.6,
  x2: 406.6,
  y2: 506.6,
  gradientTransform: "matrix(1 0 0 -1 0 570)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7e1210"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e42136"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M95.6 121l69.1-69.1H268.4l-34.6 34.5H326l80.6-80.6H118.7L3.5 121z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  gradientUnits: "userSpaceOnUse",
  x1: 46.36,
  y1: 276.3,
  x2: 371.557,
  y2: 276.3,
  gradientTransform: "matrix(1 0 0 -1 0 570)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1d70b7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2dab66"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M314.5 236.1l-69.1 69.1H141.7l34.6-34.5H84.1L3.5 351.3h287.9l115.2-115.2z"
}));

const SvgLogoWithoutSubtextGradient = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 412.1 357.6",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoWithoutSubtextGradient, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-without-subtext-gradient.63f86b82.svg";
export { ForwardRef as ReactComponent };